<template>
	<AppContent>
		<div class="tvtime-importer-page">
			<TvtimeImporter />
		</div>
	</AppContent>
</template>

<script setup lang="ts">
import TvtimeImporter from '@/features/tvtime-importer/TvtimeImporter.vue';
</script>

<style lang="scss" scoped>
.tvtime-importer-page {
	display: flex;
	justify-content: center;
	padding: 60px 16px;
}
</style>
